import { createContext, useContext, useEffect, useRef, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("bazaro_lang") || "ar");

  const apply = useCallback((l) => {
    const dir = l === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", l);
  }, []);

  const first = useRef(true);
  useEffect(() => {
    apply(lang);
    if (first.current) { first.current = false; return; }
    window.dispatchEvent(new Event("bazaro-lang-change"));
  }, [lang, apply]);

  const setLang = (l) => {
    localStorage.setItem("bazaro_lang", l);
    setLangState(l);
  };

  const toggleLang = () => setLang(lang === "ar" ? "en" : "ar");

  const t = useCallback((key) => translations[lang][key] ?? translations.ar[key] ?? key, [lang]);

  const dir = lang === "ar" ? "rtl" : "ltr";

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t, dir }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
